import { NavigationContainer, DefaultTheme } from '@react-navigation/native';
import { createStackNavigator, HeaderBackButton } from '@react-navigation/stack';
import * as React from 'react';

import NotFoundScreen from '../src/screens/NotFoundScreen';
import { RootStackParamList } from '../types';
import Home from "../src/screens/Home";
import Picture from "../src/screens/Picture";
import Preview from "../src/screens/Preview";
import Result from "../src/screens/Result";

export default function Navigation() {
  return (
    <NavigationContainer
      theme={DefaultTheme}>
      <RootNavigator />
    </NavigationContainer>
  );
}

const Stack = createStackNavigator<RootStackParamList>();

function RootNavigator() {
  return (
    <Stack.Navigator screenOptions={{ headerShown: true, title: 'Avatar Immersia' }}>
      <Stack.Screen name="Home" component={Home} options={{ headerTitle: 'Immersia - Générateur d\'Avatars / Avatar Generator' }} />
      <Stack.Screen name="Picture" component={Picture} options={{ headerTitle: 'Prise de photo / Photo capture' }} />
      <Stack.Screen name="Preview" component={Preview} options={{ headerTitle: 'Aperçu / Preview' }} />
      <Stack.Screen
        name="Result"
        component={Result}
        options={({ navigation }) => ({ headerTitle: 'Résultat / Result', headerLeft:() => <HeaderBackButton onPress={()=>{navigation.navigate('Home')}} /> })}
      />
      <Stack.Screen name="NotFound" component={NotFoundScreen} options={{ title: 'Oops!' }} />
    </Stack.Navigator>
  );
}
